import { Swiper } from 'swiper';
import { Autoplay, A11y, Navigation } from 'swiper/modules';
import afterPaint from '../../../js/__utils/afterPaint';

const sliders = document.querySelectorAll('.block-hero-centered .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		afterPaint(() => {
			const instance = new Swiper(slider, {
				// Renamed from swiper to instance
				loop: true,
				grabCursor: true,
				spaceBetween: 20,
				slidesPerView: 'auto',
				freeMode: true,
				centeredSlides: true,
				modules: [A11y, Autoplay, Navigation],
				a11y: {
					itemRoleDescriptionMessage: 'slide',
				},
				disableOnInteraction: true,
				speed: 44000,
				autoplay: {
					delay: 0,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				},

				navigation: {
					prevEl: slider.parentElement.querySelector(
						'.swiper-button-prev'
					),
					nextEl: slider.parentElement.querySelector(
						'.swiper-button-next'
					),
				},
				breakpoints: {
					0: {
						spaceBetween: 4.5,
					},
					576: {
						spaceBetween: 8,
					},
					768: {
						spaceBetween: 20,
					},
					1200: {
						spaceBetween: 20,
					},
				},
				on: {
					transitionEnd(swiper) {
						if (1 === swiper.activeIndex) {
							swiper.loopFix();
						}
					},
				},
			});

			slider.addEventListener('mouseenter', () => {
				instance.autoplay.stop();
			});
			slider.addEventListener('mouseleave', () => {
				instance.autoplay.start();
			});
		});
	});
}
